module.exports = __webpack_public_path__ + "media/images/design/images/arrows/slider_arrow_right-faf8faeafc70b07ac59d7f65e7c7830a.png";